<template>

    <div id="menu" v-click-outside="hide">

        <a class="menu-header" :class="{ active: show }" @click.prevent="toggle">
            <div class="company">
                <span class="name" :title="user.company.name">{{ user.company.name }}</span>
                <i class="fas fa-chevron-right ml-5"></i>
            </div>
            <div v-if="project" class="project" :title="project.name">{{ project.name }}</div>
        </a>

        <transition name="slide-fade">
            <div class="menu-body" v-if="show">
                <div class="menu-body-header">
                    <div class="name">{{ user.name }}</div>
                    <div class="email">{{ user.email }}</div>
                </div>
                <a class="menu-link" href="#" @click.prevent="push('account-settings')">Account</a>
                <a class="menu-link" href="#" @click.prevent="push('company-settings')">Company</a>
                <a v-if="['owner', 'admin'].includes(user.member.role.slug)" class="menu-link" href="#" @click.prevent="push('members')">Members</a>
                <a v-if="['owner'].includes(user.member.role.slug)" class="menu-link" href="#" @click.prevent="push('billing')">Billing</a>
                <a class="menu-link" href="#" @click.prevent="logout"><span class="text-danger">Log Out</span></a>
                <div class="menu-divider"></div>
                <a class="menu-link" href="#" @click.prevent="showCompanies = !showCompanies">
                    <i class="icon fas fa-random"></i>
                    <span>Switch Company</span>
                </a>
                <transition name="fade">
                    <div v-if="showCompanies && user.companies.length">
                        <div class="menu-divider mb-0"></div>
                        <div class="companies pt-10 pb-10">
                            <a v-for="c in user.companies" :key="c.id" class="menu-link" href="#" @click.prevent="selectCompany(c)">{{ c.name }}</a>
                        </div>
                        <div class="menu-divider mt-0"></div>
                        <a class="menu-link" href="#" @click.prevent="createCompany">
                            <i class="icon fas fa-plus"></i>
                            <span>Create Company</span>
                        </a>
                    </div>
                    <div v-else-if="showCompanies && !user.companies.length">
                        <div class="menu-divider"></div>
                        <a class="menu-link" href="#" @click.prevent="createCompany">
                            <i class="icon fas fa-plus"></i>
                            <span>Create Company</span>
                        </a>
                    </div>
                </transition>
            </div>
        </transition>

    </div>

</template>

<style scoped lang="scss">

    #menu {

        .menu-header {
            border-bottom: 1px solid rgba(255,255,255,0.1);
            cursor: pointer;
            display: flex;
            flex-direction: column;
            padding: 15px;
            text-decoration: none;
            transition: .3s background-color;
            user-select: none;
            &:hover, &.active {
                background-color: rgba(255,255,255,0.1);
                .company .arrow { opacity: .5; }
            }
            .company {
                @include font-semibold(13px);
                align-items: center;
                color: #fff;
                display: flex;
                justify-content: space-between;
                margin-bottom: 5px;
                .name {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .project {
                @include font-semibold(11px);
                color: #fff;
                line-height: 1.6em;
                opacity: 0.7;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .menu-body {
            @include shad(3);
            background: #fff;
            border-radius: 3px;
            display: flex;
            flex-direction: column;
            left: 0;
            margin: 10px 0 0 $sidebar-width - 10px;
            overflow: hidden;
            padding-bottom: 15px;
            position: absolute;
            top: 0;
            width: $sidebar-width;
            z-index: 100;
            .companies {
                max-height: 250px;
                overflow: auto;
            }
        }

        .menu-body-header {
            background: $color-bg;
            border-bottom: 1px solid $color-rule;
            margin-bottom: 10px;
            padding: 15px;
            user-select: none;
            .name, .email {
                @include font-semibold(11px);
                line-height: 1.6em;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .email {
                opacity: 0.7;
            }
        }

        .menu-link {
            @include font-medium(13px);
            align-items: center;
            color: $color-text;
            display: block;
            line-height: 28px;
            overflow: hidden;
            padding: 0 15px;
            text-decoration: none;
            text-overflow: ellipsis;
            transition: all .3s;
            user-select: none;
            white-space: nowrap;
            &:hover {
                background: $color-highlight;
            }
            .icon {
                color: $color-primary;
                width: 20px;
            }
        }

        .menu-divider {
            border-top: 1px solid $color-rule;
            margin: 10px 0;
        }

    }

</style>

<script>

import ClickOutside from 'vue-click-outside';
import UserApi from '@api/UserApi';

export default {

    directives: {
        ClickOutside,
    },

    data() {
        return {
            show: false,
            showCompanies: false,
        }
    },

    computed: {

        user() {
            return this.$store.getters.user;
        },

    },

    methods: {

        toggle() {
            if (this.show) {
                this.hide();
            } else {
                this.show = true;
            }
        },

        hide() {
            this.show = false;
            this.showCompanies = false;
        },

        push(name) {
            this.hide();
            this.$router.push({ name: name });
        },

        logout() {
            this.hide();
            this.$store.commit('showModal', 'logout');
        },

        selectCompany(company) {
            this.hide();
            this.$store.commit('loading', true);
            UserApi.updateCompany(company.id)
                .then((response) => {
                    if (this.$route.name === 'projects') {
                        this.$router.go();
                    } else {
                        this.$store.commit('loading', false);
                        this.$router.push({ name: 'projects' });
                    }
                }, (error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

        createCompany() {
            this.hide();
            this.$store.commit('showModal', 'company-create');
        },

    },

}

</script>
